import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
export var api__getOrderTrackingList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _res$data;
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().get("/order/combine-tracking-list");
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || []);
      }
    }, _callee);
  }));
  return function api__getOrderTrackingList() {
    return _ref.apply(this, arguments);
  };
}();
export var api__getTrackingFinanceDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(orderId) {
    var res;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetcher().get("/finance/tracking-details?id=".concat(orderId));
        case 1:
          res = _context2.v;
          return _context2.a(2, res.data.data);
      }
    }, _callee2);
  }));
  return function api__getTrackingFinanceDetails(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__getAllFinanceOfferedDoc = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(orderId) {
    var res;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return fetcher().get("/finance-tracking/view-all-offered-documents?order_id=".concat(orderId));
        case 1:
          res = _context3.v;
          return _context3.a(2, res.data.data);
      }
    }, _callee3);
  }));
  return function api__getAllFinanceOfferedDoc(_x2) {
    return _ref3.apply(this, arguments);
  };
}();